/**
 * @fileoverview Entity Picker cart dropdown component
 * @author Sahil Parikh sparikh@yext.com
 */

goog.declareModuleId('yext.ui.components.entitypicker.cart.CartItemDropdown');
import {ItemTypes} from '/ui/components/entitypicker/container/itemtypes';
import {yext} from '/ui/lib/msg';


export class CartItemDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
    };
    const id = this.props.type ? '-' + this.props.type.toLowerCase() : '';
    this.itemsId = 'uep-cart-items' + id;
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState(state => ({
      collapsed: !state.collapsed,
    }));
  }

  render() {
    const numItems = this.props.numItems;
    const itemType = itemTypeFromString(this.props.type, this.props.usingEntities);
    const allSelected = this.props.allSelected;
    const itemTypeInAllSelected = allSelected.includes(itemType);
    const isEmpty = !numItems;

    let toggleButtonClass = 'uep-cart-toggle uep-cart-title';
    let itemListClass = this.props.multiType ? 'uep-multitype-cart-items' : 'uep-cart-items';

    if (this.state.collapsed || isEmpty || itemTypeInAllSelected) {
      toggleButtonClass += ' uep-cart-collapsed';
      itemListClass += ' uep-cart-collapsed';
    }

    let headerClass = 'uep-cart-header';
    let headerOnClick = this.toggleCollapse;
    if (this.props.multiType) {
      headerClass = 'uep-cart-subheader';
      if (itemTypeInAllSelected) {
        toggleButtonClass += '--all-selected';
        headerOnClick = () => this.props.removeAllHandler(itemType);
      }
    }

    let message;
    const showCartEmptyMessage = isEmpty && !itemTypeInAllSelected && this.props.emptyMessage;
    if (showCartEmptyMessage) {
      message = this.props.emptyMessage;
    } else if (allSelected.includes(ItemTypes.ENTITIES)) {
      message = yext.msg('All Entities');
    } else {
      switch (this.props.type) {
        case 'ENTITIES':
          message = this.props.locationsOnly
            ? yext.msg('Locations ({0})', numItems)
            : yext.msg('Entities ({0})', numItems);
          break;
        case 'ENTITYTYPES':
          message = itemTypeInAllSelected
            ? yext.msg('All Entity Types')
            : yext.msg('Entity Types ({0})', numItems);
          break;
        case 'FOLDERS':
          message = itemTypeInAllSelected
            ? yext.msg('All Folders')
            : yext.msg('Folders ({0})', numItems);
          break;
        case 'LABELS':
          message = itemTypeInAllSelected
            ? yext.msg('All Labels')
            : yext.msg('Labels ({0})', numItems);
          break;
        default:
          message = yext.msg('Selected Items ({0})', numItems);
      }
    }

    const buttonDisabled = (isEmpty && !this.props.multiType);

    return (
      <React.Fragment>
        <div className={headerClass}>
          <button
            type="button"
            className={toggleButtonClass}
            onClick={headerOnClick}
            aria-controls={this.itemsId}
            aria-expanded={!this.state.collapsed}
            disabled={buttonDisabled}
          >
            {message}
          </button>
          {this.props.additionalHeaderChildren}
        </div>
        <ul id={this.itemsId} className={itemListClass} tid={this.itemsId}>
          {this.props.children}
        </ul>
      </React.Fragment>
    );
  }
}

function itemTypeFromString(str, usingEntities) {
  switch (str) {
    case 'ENTITIES':
      return ItemTypes.ENTITIES;
    case 'ENTITYTYPES':
      return usingEntities ? ItemTypes.ENTITIES : ItemTypes.ENTITYTYPES;
    case 'FOLDERS':
      return ItemTypes.FOLDERS;
    case 'LABELS':
      return ItemTypes.LABELS;
    default:
      return null;
  }
}
